import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';
import { LandingNav } from '@/components/landing/LandingNav';
import { HeroSection } from '@/components/landing/HeroSection';
import { TrustBarSection } from '@/components/landing/TrustBarSection';
import { ProblemSolutionSection } from '@/components/landing/ProblemSolutionSection';
import { FeaturesSection } from '@/components/landing/FeaturesSection';
import { HowItWorksSection } from '@/components/landing/HowItWorksSection';
import { TrackRouteSection } from '@/components/landing/TrackRouteSection';
import { AdvancedFeaturesSection } from '@/components/landing/AdvancedFeaturesSection';
import { PersonasSection } from '@/components/landing/PersonasSection';
import { PricingSection } from '@/components/landing/PricingSection';
import { FAQSection } from '@/components/landing/FAQSection';
import { FinalCTASection } from '@/components/landing/FinalCTASection';
import { LandingFooter } from '@/components/landing/LandingFooter';

export default function Landing() {
  const { user, organization, isLoading } = useAuthContext();

  if (user && organization && !isLoading) {
    return <Navigate to="/painel" replace />;
  }

  return (
    <div className="min-h-screen bg-white font-poppins">
      <LandingNav />
      <HeroSection />
      <TrustBarSection />
      <ProblemSolutionSection />
      <FeaturesSection />
      <HowItWorksSection />
      <TrackRouteSection />
      <AdvancedFeaturesSection />
      <PersonasSection />
      <PricingSection />
      <FAQSection />
      <FinalCTASection />
      <LandingFooter />
    </div>
  );
}
